var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDietDayImageActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 15,
    fill: "#FFEBD1",
    stroke: "#D7BD9D",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.2111 12.353C22.7525 12.8944 22.7525 13.7722 22.2111 14.3136L15.9174 20.6073C15.6574 20.8673 15.3048 21.0133 14.9371 21.0133C14.5694 21.0133 14.2168 20.8673 13.9568 20.6073L11.0197 17.6702C10.4783 17.1288 10.4783 16.251 11.0197 15.7096C11.5611 15.1682 12.4389 15.1682 12.9803 15.7096L14.9371 17.6664L20.2505 12.353C20.7919 11.8115 21.6697 11.8115 22.2111 12.353Z",
    fill: "#D7BD9D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDietDayImageActive);
export default __webpack_public_path__ + "static/media/dietDayImageActive.0b2b3730f067168243e5296c1feb4747.svg";
export { ForwardRef as ReactComponent };